import getConfiguredEventEndTimeBasedOnPreviousEnd from './getConfiguredEventEndTimeBasedOnPreviousEnd';
import getConfiguredEventStartTimeBasedOnPreviousStart from './getConfiguredEventStartTimeBasedOnPreviousStart';
import { OwaDate } from 'owa-datetime';
import { OwaDateRange } from 'owa-datetime-utils/lib/OwaDateRange';

/**
 * Update the event start time and end time when the 'End events early'/'Shorten events duration' setting is on
 * Used when selection is changed in scheduling grid and scheduling assistant
 * @param previousStart
 * @param previousEnd
 * @param newStart
 * @param newEnd
 */
export default function getConfiguredEventStartTimeEndTimeBasedOnPreviousStartEnd(
    previousStart: OwaDate,
    previousEnd: OwaDate,
    newStart: OwaDate,
    newEnd: OwaDate
): OwaDateRange {
    return {
        start: getConfiguredEventStartTimeBasedOnPreviousStart(
            previousStart,
            previousEnd,
            newStart,
            newEnd
        ),
        end: getConfiguredEventEndTimeBasedOnPreviousEnd(
            previousStart,
            previousEnd,
            newStart,
            newEnd
        ),
    };
}
